import React, { Component } from 'react';
import PropTypes from 'prop-types';
import EventBus from '../EventBus';
import Classes from '../Classes';
import MixPanelHelper from '../MixPanelHelper';
import { MixpanelEventName } from '../Constants';

class FeedbackButton extends Component {
  showSurveyPopup = () => {
    EventBus.dispatch('SurveyPopup', null);
    MixPanelHelper.trackGenericMixpanelEvents(MixpanelEventName.ParticipantInteracted, { 'Interacted Element': 'PD_Feedback' });
  };

  render() {
    return (
      <div>
        <div className={Classes.feedBackButton.xploreFeedback}>
          <button
            className={Classes.feedBackButton.xploreFeedbackButton}
            onClick={this.showSurveyPopup}
            data-dtm={this.props.dataDtm}
          >
            {this.props.feedbackText}
          </button>
        </div>
      </div>
    );
  }
}

FeedbackButton.propTypes = {
  dataDtm: PropTypes.string.isRequired,
  feedbackText: PropTypes.string.isRequired
};

export default FeedbackButton;
